import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M5.83 11L8.41 8.41L7 7L2 12L7 17L8.41 15.59L5.83 13H22V11H5.83Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LongLeft"
);
